<template>
  <Bar :chart-data="chartData" :chart-options="chartOptions" />
</template>

<script>
import { Bar } from '../../../../node_modules/vue-chartjs/dist/index'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'EnrollmentHistory',
  components: { Bar },
  data () {
    return {
      chartData: {
        labels: [],
        datasets: [
          {
            label: 'Inscripciones',
            backgroundColor: '#00AFF5',
            data: []
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true
      }
    }
  },
  async created () {
    this.years = this.$store.state.year.list
    // this.year = this.$store.state.year.selected
  },
  async mounted () {
    const labelsArray = []
    const count = []
    // const color = []
    // console.log('años:', this.years)
    this.years.forEach(element => {
      labelsArray.push(element.x_year)
      count.push(element.x_enrollment_ids.length
      )
    })
    this.chartData.labels = labelsArray
    this.chartData.datasets[0].data = count
  }
}
</script>
